var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _c(
        "app-relatorio-base",
        {
          attrs: {
            titulo: "DAEs por tipo",
            filtro: _vm.filtro,
            municipios: _vm.municipios,
            receitas: _vm.receitas,
            valorTotal: _vm.formatTotal(_vm.total),
            selecionarTodosMunicipios: true,
            selecionarTodasReceitas: true
          },
          on: {
            gerarGraficos: _vm.updateDados,
            tabChange: _vm.updateDados,
            atualizarSelecionarTodosMunicipios:
              _vm.atualizarSelecionarTodosMunicipios
          }
        },
        [
          _c(
            "el-row",
            {
              staticClass: "contentCardGrafico",
              attrs: { slot: "grafico" },
              slot: "grafico"
            },
            [
              _vm.daesTipoProcesso.length > 0
                ? _c("dae-tipo-processo", {
                    attrs: { dadosDb: _vm.daesTipoProcesso }
                  })
                : _c("p", { staticClass: "empty-div" }, [
                    _vm._v("Nenhum dado encontrado.")
                  ])
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "contentCard",
              attrs: { slot: "tabela" },
              slot: "tabela"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table-div",
                      attrs: {
                        data: _vm.daesTipoProcesso.content,
                        "empty-text": "Nenhum dado encontrado."
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Tipo de processo",
                          prop: "label",
                          sortable: "sortable"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Recebido" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.quitado
                                        )
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Vencido" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.vencido
                                        )
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Aguardando Pagamento" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.aguardandoPagamento
                                        )
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Emitido" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "R$ " +
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.emitido
                                        )
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "paginacao",
                      attrs: { slot: "pagination" },
                      slot: "pagination"
                    },
                    [
                      _c("p", { staticClass: "label-total" }, [
                        _c("b", [_vm._v("Valor total:")]),
                        _vm._v("  " + _vm._s(_vm.formatTotal(_vm.total)))
                      ]),
                      _c("app-paginacao", {
                        attrs: {
                          total: _vm.daesTipoProcesso.totalElements,
                          pagina: _vm.filtro.pagina
                        },
                        on: { changePage: _vm.changePage }
                      }),
                      _c(
                        "el-row",
                        { staticClass: "button-row" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "default", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.exportarCsvTipoProcesso()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fal fa-file-csv" }),
                              _c("span", [_vm._v("  Exportar CSV")])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08cb2d14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08cb2d14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/relatoriosDae/DaesTipoProcesso.vue
// module id = null
// module chunks = 